import { CurrentUser } from "hooks/useCurrentUser";
import { BatchState } from "hooks/useFulfillmentBatch";
import { redirect } from "react-router-dom";
import { fetcher } from "services/api.service";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  const { currentFulfillmentBatch: batch } = await fetcher<CurrentUser>("/current_user");
  if (batch && batch.state !== BatchState.Complete) {
    return redirect(`/picklist/batches/${batch.id}`);
  } else {
    return redirect("/picklist/new");
  }
});
